import styled from 'styled-components';

export default styled.img<{ size?: number; border?: boolean }>`
  border-radius: 50%;
  height: ${(p) => p.size || 40}px;
  width: ${(p) => p.size || 40}px;

  border: ${(p) => (p.border ? '3px solid white' : 'none')};
`;
